import { FC, ReactNode, useCallback } from "react";
import "./PageBase.scss";
import { Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImagePortrait } from "@fortawesome/free-solid-svg-icons";
import { BvIcon } from "bevi-icon";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import ButtonGroup from "../ButtonGroup/ButtonGroup";

interface PageBaseProps {
  title?: string;
  complementTitle?: string;
  subtitle?: string;
  icon?: string;
  hasPagination?: boolean;
  handleFilter?: any;
  hasFilter?: boolean;
  textButtonFilter?: string;
  showCardHeader?: boolean;
  handleInsert?: any;
  error?: string;
  renderBtnAux?: any;
  renderBtnAux2?: any;
  renderBtnAux3?: any;
  children?: ReactNode;
  useButtonGroup?: boolean;
  scrollableButtons?: boolean;
}

const PageBase: FC<PageBaseProps> = ({
  title,
  complementTitle,
  subtitle,
  icon,
  hasPagination = true,
  showCardHeader = true,
  handleInsert,
  handleFilter,
  hasFilter,
  textButtonFilter = "Filtros",
  error = "",
  renderBtnAux,
  renderBtnAux2,
  renderBtnAux3,
  children,
  useButtonGroup = false,
  scrollableButtons = false,
}) => {
  const location = useLocation();
  const isArticlesRoute = /\/(articles\/(sections|subsections)|articles)\/list$/.test(location.pathname);

  useCallback(async () => {
    error && (await Swal.fire("Ops!", error, "error"));
  }, [error]);

  return (
    <div className="PageBase" data-testid="PageBase">
      <Row>
        <Col md={12}>
          <Card>
            {showCardHeader && (
              <Card.Header className="pb-0">
                <div className="d-lg-flex">
                  <div>
                    {icon ? (
                      <div className="icon">
                        <FontAwesomeIcon
                          icon={faImagePortrait}
                          className="ms-2"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div>
                      <h5 className="mb-0">{title}</h5>
                      <p className="text-sm mb-0">{subtitle}</p>
                    </div>
                  </div>
                  <div className="ms-auto my-auto mt-lg-0 mt-4">
                    <div className="ms-auto my-auto">
                      {useButtonGroup ? (
                        <ButtonGroup>
                          {handleInsert && (
                            <button
                              type="button"
                              className="btn bg-primary text-white btn-sm mb-0"
                              onClick={handleInsert}
                            >
                              +&nbsp; Cadastrar
                            </button>
                          )}

                          {renderBtnAux}
                          {renderBtnAux2}
                          {renderBtnAux3}

                          {hasFilter && (
                            <button
                              type="button"
                              className={`btn btn-default-filters btn-sm mb-0 ${isArticlesRoute ? 'btn-articles-mobile-filter' : ''}`}
                              onClick={handleFilter}
                            >
                              <span>{textButtonFilter}</span>
                              <BvIcon
                                name="filter"
                                variant="light"
                                width={16}
                                height={16}
                                className={`ms-1 bv-icon-default ${isArticlesRoute ? 'icon-articles-filter' : ''}`}
                                color="var(--primary)"
                              />
                            </button>
                          )}
                        </ButtonGroup>
                      ) : (
                        <div className={`button-wrapper d-flex overflow-y-auto pb-3 gap-2 ${scrollableButtons ? 'button-wrapper--scroll' : ''}`}>
                          {handleInsert && (
                            <div>
                              <button
                                type="button"
                                className="btn bg-primary text-white btn-sm mb-0"
                                onClick={handleInsert}
                              >
                                +&nbsp; Cadastrar
                              </button>
                            </div>
                          )}

                          {renderBtnAux}
                          {renderBtnAux2}
                          {renderBtnAux3}

                          {hasFilter && (
                            <button
                              type="button"
                              className={`btn btn-default-filters btn-sm mb-0 ${isArticlesRoute ? 'btn-articles-mobile-filter' : ''}`}
                              onClick={handleFilter}
                            >
                              <span>{textButtonFilter}</span>
                              <BvIcon
                                name="filter"
                                variant="light"
                                width={16}
                                height={16}
                                className={`ms-1 bv-icon-default ${isArticlesRoute ? 'icon-articles-filter' : ''}`}
                                color="var(--primary)"
                              />
                            </button>
                          )}
                        </div>
                      )}

                      {/* <button type="button" className="btn btn-outline-primary btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#import">
                        Importar
                      </button>

                      <button className="btn btn-outline-primary btn-sm export mb-0 mt-sm-0 mt-1" data-type="csv" type="button" name="button">Exportar</button> */}
                    </div>
                  </div>
                </div>
              </Card.Header>
            )}
            <Card.Body className={`${hasPagination ? "pb-2" : ""}`}>
              {children}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PageBase;
